import Candidate from '@/orm/models/Candidate/Candidate';

export default function useCandidateCommunication() {
  async function fetchCommunication(code) {
    const res = await Candidate.api().fetchCommunication(code);
    return res.response.data.data ?? res.response.data;
  }

  async function fetchCommunicationMessagesByCandidate(candidateId, params = { page: 1, perPage: 50 }) {
    const res = await Candidate.api().fetchCommunicationMessagesByCandidate(candidateId, params);
    const raw = res.response.data.data ?? res.response.data ?? [];
    const normalized = Array.isArray(raw) ? raw : [];
    return [...normalized].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  }

  async function sendCommunicationMessageByCandidate(candidateId, message) {
    return Candidate.api().sendCommunicationMessageByCandidate(candidateId, { message });
  }

  async function markAsRead(candidateId) {
    return Candidate.api().markCommunicationAsRead(candidateId);
  }

  return {
    fetchCommunication,
    fetchCommunicationMessagesByCandidate,
    sendCommunicationMessageByCandidate,
    markAsRead,
  };
}